import {setCookie, 
    getCookie
} from './cookie-control';

export default () => {
    
    const passwordPages = document.querySelectorAll(".password-page");

    if (passwordPages.length > 0) {
        passwordPages.forEach(pass =>{
            const dataDeadline = pass.querySelector('[data-time="timer-deadline"]').getAttribute("data-timer-deadline");

            if (dataDeadline) {
                const deadline = new Date(dataDeadline).getTime();

                const x = setInterval(() => {
                    const now = new Date().getTime();
                    const t = deadline - now;
                    const days = Math.floor(t / (1000 * 60 * 60 * 24));
                    const hours = Math.floor(
                    (t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                    );
                    const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));

                    pass.querySelector('[data-time="timer-days"]').innerHTML = days;
                    pass.querySelector('[data-time="timer-hours"]').innerHTML = hours;
                    pass.querySelector('[data-time="timer-minutes"]').innerHTML = minutes;

                    if (t < 0) {
                        clearInterval(x);
                        pass.querySelector('[data-time="timer-days"]').innerHTML = "0";
                        pass.querySelector('[data-time="timer-hours"]').innerHTML = "0";
                        pass.querySelector('[data-time="timer-minutes"]').innerHTML = "0";
                    }
                }, 1000);
            }
            if (pass.classList.contains('password-popup')){
                
                if( !getCookie('closed-collection')){
                    
                    pass.classList.add('active')
                    document.body.style.overflow="hidden"
                } else {
                    window.location.pathname != '/'?document.querySelector('header').style.opacity = 1: false
                    // document.querySelector('header').style.opacity = 1;
                    pass.classList.remove('active');
                   
                }
                
            //     const closeButton = pass.querySelector('.password-page-close');
    
            //     closeButton.addEventListener('click', () =>{
            //         pass.classList.remove('active');
            //         setCookie('closed-collection', true, 0);
            //     })
            }
        })
        

        

        // #region change tabs
            const changeStateButtons = document.querySelectorAll('[data-pass-open]');
            const tabs = document.querySelectorAll('[data-pass-wrapper]');

            document.querySelector('.password-form-box').style.height = document.querySelector('.password-form-box__inner').scrollHeight + 'px';

            changeStateButtons.forEach(button => {
                button.addEventListener('click', ()=>{
                    const activeTab = button.dataset.passOpen;
                    setActiveAnchor(activeTab)
                })
            })
            function setActiveAnchor(anchor){
                tabs.forEach((tab, ind) =>{
                    const tabName = tab.dataset.passWrapper;
                    if(tabName == anchor){
                        tab.classList.add('active');
                    } else {
                        tab.classList.remove('active');
                    }
                })
            }
            //
        //#endregion
        
        //#region check password
            const md5 = require('md5');
            const passwordInput = document.querySelector('#page-md-value');
            const formPassword = document.querySelector('#password-enter');
            formPassword.addEventListener('submit', (e) => {
                e.preventDefault();
                const val = e.target[0].value;
                passwordInput.value == md5(val)? openCollection() : document.querySelector('.password-form-box__error').classList.add('active');
                
            })

            function openCollection(){
                document.querySelector('.password-form-box__error').classList.remove('active')
                setCookie('closed-collection', true, 30, 30);
                window.location.href = passwordInput.dataset.collection;
            }
            
        //#endregion
    } else {
        document.querySelector('header').style.opacity = 1;
    }
};
